import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

// Expects these properties:
//   item_count -- how many buttons to show
//   clickHandler -- callback to be called with item number when clicked.
//   buttonLabeler -- callback to be called to generate the button label
//   buttonStyler -- optional bootstrap style; defaults to "info"

// You might wish to wrap these in a ButtonGroup (or not).

class ButtonSequence extends Component {
  render() {
    let button_list = [...Array(this.props.item_count).keys()].map(i => (
      <Button
        data-tooltip={
          this.props.toolTipTextGenerator
            ? this.props.toolTipTextGenerator(i)
            : null
        }
        bsStyle={this.props.buttonStyler ? this.props.buttonStyler(i) : 'info'}
        key={i + 1}
        onClick={() => this.props.clickHandler(i)}
      >
        {this.props.buttonLabeler(i)}
      </Button>
    ));

    return button_list;
  }
}

export default ButtonSequence;



// WEBPACK FOOTER //
// ./src/ButtonSequence.js